<script lang="ts">
  import translationsStore from '../../../stores/translations.svelte'
  import videoStore from '../../../stores/video.svelte'
  import PipIcon from '../icons/PipIcon.svelte'
  import ControlBarButton from './ControlBarButton.svelte'
  import { CONTROL_BAR_BUTTON_TOOLTIP_POSITION } from './ControlBarButton.svelte'
  import type { ControlBarButtonProps } from './ControlBarButton.svelte'

  let {
    tooltipPosition = CONTROL_BAR_BUTTON_TOOLTIP_POSITION.CENTER,
  }: Pick<ControlBarButtonProps, 'tooltipPosition'> = $props()
</script>

<ControlBarButton
  onclick={() => videoStore.state.videoController?.togglePip()}
  tooltip={translationsStore.state.pip}
  {tooltipPosition}
  hidden={videoStore.state.isChromecasting ||
    !videoStore.state.isPicureInPictureSupported}
>
  <PipIcon />
</ControlBarButton>
